import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  standalone: true,
  selector: 'equine-ui-nx-ach-confirmation-dialog',
  templateUrl: './ach-confirmation-dialog.component.html',
  styleUrls: ['./ach-confirmation-dialog.component.scss'],
  imports: [MatDialogModule, MatButtonModule]
})
export class AchConfirmationDialogComponent {

  constructor() { }

}
